import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { forwardRef } from 'react';
import { styled, StyleSheet, text } from '@rexlabs/styling';
import Box from '@rexlabs/box';
var defaultStyles = StyleSheet({
  input: {
    textOverflow: 'ellipsis',
    // We want the selects onClick to trigger for read only
    // dropdowns, disabled inputs swallow mouse events, so the
    // easiest way to get around that is to disable pointer events
    // here :D
    pointerEvents: 'none'
  },
  // We don't want to have to reproduce
  // native placeholder behaviour here
  // so we are using a normal disabled input
  // to view values
  enabled: {
    '&:disabled': _objectSpread({}, text.styles({
      target: 'textInput.input',
      fallback: 'normal.default',
      color: function color(_ref) {
        var token = _ref.token;
        return token('textStyle.body.default.color');
      }
    }))
  }
});

function TextSelectInputBase(_ref2) {
  var s = _ref2.styles,
      style = _ref2.style,
      className = _ref2.className,
      innerRef = _ref2.innerRef,
      disabled = _ref2.disabled,
      Value = _ref2.Value,
      props = _objectWithoutProperties(_ref2, ["styles", "style", "className", "innerRef", "disabled", "Value"]);

  return /*#__PURE__*/React.createElement(Box, {
    flex: 1
  }, /*#__PURE__*/React.createElement("input", _extends({
    ref: innerRef
  }, props, s.with('input', {
    enabled: !disabled
  })({
    style: style,
    className: className
  }), {
    disabled: true
  })));
}

var StyledTextSelectInputBase = styled(defaultStyles)(TextSelectInputBase);
var TextSelectInput = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(StyledTextSelectInputBase, _extends({}, props, {
    innerRef: ref
  }));
});
TextSelectInput.displayName = 'TextSelectInput';
export default TextSelectInput;